<template>
	<div class="cafsmodal" v-if="activeModal" ref="modal">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="modal-header mb-8">
						<h1>{{ title }}</h1>
						<button @click="closeModal" class="btn btn-lg btn-success" data-cy="close-modal">
							<b-icon icon="check"></b-icon>
							{{ $t('done') }}
						</button>
					</div>
					<div class="modal__content">
						<Selector
							v-if="activeModal === 'selector'"
							:modalSettings="this.$store.state.modalSettings"
						/>
						<FileUpload
							v-if="activeModal === 'fileUpload'"
							:modalSettings="this.$store.state.modalSettings"
						/>
						<Message
							v-if="activeModal === 'message'"
							:modalSettings="this.$store.state.modalSettings"
							@closeModalEmit="closeModal"
						/>
						<!--TimeSeries
						 	v-if="activeModal === 'plot'"
							:parameters="this.$store.state.modalSettings"
						/-->

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Selector from "./modals/Selector";
import FileUpload from "./modals/FileUpload";
import Message from "./modals/Message";
//import TimeSeries from "./Reports/TimeSeries";


export default {
	components: {
		Selector,
		FileUpload,
		Message
		//TimeSeries
	},
	data () {
		return {
			loadedCSV: []
		}
	},
	methods: {
		closeModal() {
			this.$store.commit("closeModal");
		},
	},
	computed: {
		title() {
			return this.$store.state.modalSettings.title;
		},
		activeModal() {
			return this.$store.state.modalSettings.type;
		},
	}
};
</script>
